export default __webpack_public_path__ + "static/media/pattern4.6fced9d8.png";